import { render } from "./PdfPreview.vue?vue&type=template&id=ae5db540&scoped=true"
import script from "./PdfPreview.vue?vue&type=script&lang=js"
export * from "./PdfPreview.vue?vue&type=script&lang=js"

import "./PdfPreview.vue?vue&type=style&index=0&id=ae5db540&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ae5db540"]])

export default __exports__